import { ComponentType } from "react";
import { TaskNameFragment } from "gql/graphql";
import { LocalizedName } from "@/shared/data-display/localized-value";
import { Hidable, Value } from "@/shared/value";

/**
 * Название задачи. Задача — защищённая сущность и приезжает вложенной в списки,
 * уведомления и подзадачи, поэтому `name.value` на месте показа не разворачивается.
 */
export function TaskName({
  data,
  whenEmpty,
}: {
  data?: Hidable<TaskNameFragment>;
  whenEmpty?: ComponentType;
}) {
  return (
    <Value data={data} whenEmpty={whenEmpty}>
      {(task) => <LocalizedName data={task.name} whenEmpty={whenEmpty} />}
    </Value>
  );
}
